export function ChapterWipe({ wipeState, chapterCfg }) {
  return (
    <div className={`chapter-wipe ${wipeState === 'in' ? 'active' : ''} ${wipeState === 'out' ? 'out' : ''}`} aria-hidden="true">
      <div className="wipe-inner">
        <div className="wipe-num">{chapterCfg.num}</div>
        <span className="wipe-label">{chapterCfg.name}</span>
      </div>
    </div>
  )
}
